// to match the prefixes in app/models/integration_setting.rb

export const CHATS_PREFIX = 'chats.'
export const MAILBOXES_PREFIX = 'mailboxes.'
